<template>
  <div>
    <label v-if="label" class="jm-mb-2" data-test="input-label">{{
      label
    }}</label>
    <input
      class="jm-p-2"
      v-bind="$attrs"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      data-test="input"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [String, Number],
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
label,
input {
  display: block;
}

input {
  box-sizing: border-box;
  width: 100%;
  border: $border-width-sm solid $border-color-input;
  border-radius: $border-radius-base;
  &::placeholder {
    font-style: italic;
    color: $grey-300;
  }
}
</style>
